
























import { defineComponent } from '@vue/composition-api'
import Headers from '@/components/v2/headers/index.vue'
import HeaderUnders from '@/components/v2/headers/unders.vue'
import MobileRender from '@/components/mobile-render/index.vue'
import PageList from '@/components/v2/page-list/index.vue'
import NodeTool from '@/components/node-style-tools/index.vue'
import PageSet from '@/components/v2/page-set/index.vue'
import NodeSet from '@/components/v2/node-set/index.vue'
import CodeEditorNew from '@/components/v2/code-editor2/index.vue'
import CodeEditor from '@/components/v2/code-editor-modal/index.vue'
import ImageResource from '@/components/image-resource/index.vue'
import SearchCode from '@/components/search-code/index.vue'
import { http } from '@/api'
import Vue from 'vue'
import { Message } from 'element-ui'
import { initProject, resetProject } from '@/assets/project'
import { lock, unlock, useLock } from '@/assets/lock'
import { showImageResource, showSearchCode, clearEditWrapCacheNode } from '@/assets/render'
import { isEditNew } from '@/assets/code-edit'

export default defineComponent({
  components: {
    Headers,
    HeaderUnders,
    MobileRender,
    PageList,
    NodeTool,
    PageSet,
    NodeSet,
    CodeEditor,
    CodeEditorNew,
    ImageResource,
    SearchCode
  },

  beforeRouteLeave (to: any, from: any, next: any) {
    // @ts-ignore
    const { dir } = this.$route.params
    if (dir && !from.query.timeout) {
      unlock(dir).then(() => {
        next()
      })
    } else {
      next()
    }
  },

  setup (props, ctx) {
    const dir = ctx.root.$route.params.dir
    clearEditWrapCacheNode()
    resetProject()
    http.get('project/get', { dir, name: Vue.prototype.$native.name }, {
      codeCallback: {
        6001: (res: any) => {
          Message.error(res.msg)
          resetProject()
          setTimeout(() => {
            history.back()
          }, 1000)
        }
      }
    }).then(item => {
      initProject(item.data.project)
      lock(dir)
    })

    // watch(() => [project.interactiveType, project.depLoaded], ([type, loaded]) => {
    //   if (loaded) {
    //     console.log(1)
    //     loadSdk(type as string)
    //   }
    // }, { lazy: true })
    useLock()

    return {
      showImageResource,
      showSearchCode,
      isEditCode: isEditNew
    }
  }
})
